module.exports = __webpack_public_path__ + "fonts/android_svgrepo.com.svg";